import moment, { Moment } from "moment";
import { Phone } from "./phone";

export interface ApplicantInputValueDto {
  birthDate: string | null;
  firstName: string | null;
  middleName: string | null;
  lastName: string | null;
  phoneCountryCode: string | null;
  phoneNumber: string | null;
}

export class ApplicantInputValue {
  birthDate: Moment | null;
  name: {
    firstName: string | null;
    middleName: string | null;
    lastName: string | null;
  } | null;
  phone: Phone | null;

  constructor(dto: ApplicantInputValueDto) {
    this.birthDate = (dto.birthDate && moment(dto.birthDate)) || null;
    this.name =
      !!dto.firstName || !!dto.middleName || !!dto.lastName
        ? {
            firstName: dto.firstName,
            middleName: dto.middleName,
            lastName: dto.lastName,
          }
        : null;
    this.phone =
      dto.phoneCountryCode && dto.phoneNumber
        ? new Phone(dto.phoneCountryCode, dto.phoneNumber)
        : null;
  }
}
